import service from '@/store/services/fms/driver-service';

const state = {
  list: {},
  driver: {},
  meta: {}
};

const mutations = {
  SET_LIST: (state, list) => {
    state.list = list;
  },
  SET_RESOURCE: (state, driver) => {
    state.driver = driver;
  },
  SET_META: (state, meta) => {
    state.meta = meta;
  }
};

const actions = {
  list({commit, dispatch}, params) {
    return service.list(params)
      .then(({list, meta}) => {
        commit('SET_LIST', list);
        commit('SET_META', meta);
      });
  },


  get({commit, dispatch}, params) {
    return service.get(params)
      .then((driver) => { commit('SET_RESOURCE', driver); });
  },

  listActiveByLocation({commit, dispatch}, params) {
    return service.listActiveByLocation(params)
      .then((driver) => { commit('SET_RESOURCE', driver); });
  },

  add({commit, dispatch}, params) {
    return service.add(params)
      .then((driver) => { commit('SET_RESOURCE', driver); });
  },

  update({commit, dispatch}, params) {
    return service.update(params)
      .then((driver) => { commit('SET_RESOURCE', driver); });
  },

  update_status({commit, dispatch}, params) {
    return service.update_status(params)
      .then((driver) => { commit('SET_RESOURCE', driver); });
  },

  destroy({commit, dispatch}, params) {
    return service.destroy(params);
  },

  last_no({commit, dispatch}, params) {
    return service.last_no(params)
      .then((driver) => { commit('SET_RESOURCE', driver); });
  },
  
  bill_payment({commit, dispatch}, params) {
    return service.bill_payment(params)
      .then((driver) => { commit('SET_RESOURCE', driver); });
  },

  LisOutstanding({commit, dispatch}, params) {
    return service.LisOutstanding(params)
      .then((driver) => { commit('SET_RESOURCE', driver); });
  }
};

const getters = {
  list: state => state.list,
  listTotal: state => state.meta.page.total,
  driver: state => state.driver,
  page: state => state.meta.page,
};
 
const driver = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};

export default driver;
